module.exports = __webpack_public_path__ + "img/FSBS_big sword v1.ecf852ee.png";